<template>
  <div>
    <AppTabs
      :value="value"
      :tabs="tabs"
      @input="$event => $router.push({ name: $event.key })"
    />
    <hr class="mt-3 mb-3" />
    <KeepAlive>
      <router-view />
    </KeepAlive>
  </div>
</template>

<script>
export default {
  computed: {
    value () {
      return { key: this.$route.name }
    },
    tabs () {
      return [
        { key: 'smSettingsTimeBlocksStandard', label: 'Standard Meeting Patterns' },
        { key: 'smSettingsTimeBlocksExam', label: 'Exam Meeting Patterns' },
      ]
    },
  },
}
</script>
